/** A pending placement is retained until its source actually joins the raster.
 * Failed load/composition must not permit a family transition or paid Paint. */
export async function finalizePreparedSource(compose:()=>Promise<void>, accepted:()=>void, rejected:(error:unknown)=>void):Promise<boolean>{
  try{await compose();accepted();return true;}
  catch(error){rejected(error);return false;}
}

/** Clear/Undo can leave no visible pixels while still retaining recoverable work. */
export function hasRecoverableDraft(state:{drawn:boolean;canUndo:boolean;canRedo:boolean}|null|undefined,pending=false):boolean{
 return pending||!!state&&(state.drawn||state.canUndo||state.canRedo);
}
